import { articleLinks } from '@/mocks/articles';

export default function ArticleLinks() {
  return (
    <section className="py-14 md:py-20 px-4 md:px-6 bg-background-100">
      <div className="max-w-[1000px] mx-auto">
        <div className="text-center mb-10">
          <h2 className="font-heading text-2xl md:text-3xl font-semibold text-foreground-900 mb-3">
            In-Depth Guides & Resources
          </h2>
          <p className="text-sm text-foreground-600 max-w-[560px] mx-auto">
            Dive deeper into product discovery with our comprehensive guides, comparisons, and shopping tips
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          {articleLinks.map((article) => (
            <a
              key={article.slug}
              href={`/${article.slug}/`}
              className="group flex flex-col p-5 rounded-lg bg-background-50 border border-background-200/60 hover:border-primary-200 transition-all cursor-pointer"
            >
              <div className="flex items-center gap-3 mb-3">
                <span className="inline-block px-2.5 py-0.5 rounded-full bg-secondary-100 text-secondary-700 text-xs font-semibold">
                  {article.category}
                </span>
              </div>
              <h3 className="font-heading text-base md:text-lg font-semibold text-foreground-900 mb-2 group-hover:text-primary-600 transition-colors leading-snug">
                {article.title}
              </h3>
              <p className="text-xs md:text-sm text-foreground-600 leading-relaxed mb-3 flex-1">
                {article.description}
              </p>
              <div className="flex items-center gap-1.5 text-sm font-medium text-primary-600 group-hover:text-primary-700 transition-colors whitespace-nowrap">
                <span>Read Article</span>
                <i className="ri-arrow-right-line text-sm"></i>
              </div>
            </a>
          ))}
        </div>

        <div className="text-center mt-8">
          <a
            href="/kakobuy-spreadsheet-guide/"
            className="inline-flex items-center gap-2 px-6 py-3 text-sm font-semibold rounded-lg bg-secondary-100 text-secondary-800 hover:bg-secondary-200 transition-colors whitespace-nowrap cursor-pointer"
          >
            View All Guides
            <i className="ri-arrow-right-line"></i>
          </a>
        </div>
      </div>
    </section>
  );
}